import {
  createLive, getLive, listLive, getLastestOne
} from '@/zsm-api-new/live.js'
const state = {

}

const mutations = {

}

const actions = {
  // 获取最近的一条数据
  getLastestOne({ commit }, frontId) {
    return new Promise((resolve, reject) => {
      getLastestOne(frontId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取列表数据
  listLive({ commit }, frontId) {
    return new Promise((resolve, reject) => {
      listLive(frontId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取单条数据
  getLive({ commit }, id) {
    return new Promise((resolve, reject) => {
      createLive(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建直播申请
  createLive({ commit }, data) {
    return new Promise((resolve, reject) => {
      createLive(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
